module.exports = __webpack_public_path__ + "static/Syberia1-18d36a046f035976a3a1978526a2d2ad.webp";